<template>
  <v-container fluid align-start ma-0 px-2 pt-2 pb-8 class="epms0100-main container-height d-flex justify-center overflow-auto">
    <div class="d-flex">
      <div class="col-left px-2 mr-12">
        <div class="list-title">
          <v-icon class="mt-n1">
            mdi-note-text-outline
          </v-icon>
          What's New
        </div>

        <div v-for="(item, idx) in countList" :key="'whats-new_' + idx" class="whats-new pt-2 d-flex justify-space-between">
          <div class="item-title" @click.stop="goList(item.title)">
            <v-icon class="mt-n1">
              mdi-arrow-right-box
            </v-icon>
            {{ item.title }}
          </div>

          <div class="item-cnt d-flex justify-end pr-1">
            {{ item.cnt }}
          </div>
        </div>

        <div class="py-2" />

        <div v-for="(item, idx) in btnList" :key="'btn_' + idx" class="pt-2 d-flex">
          <v-btn small @click.stop="clickBtns(item.title)">
            <v-icon small class="mt-n1">
              mdi-arrow-right-box
            </v-icon>
            {{ item.title }}
          </v-btn>
        </div>
      </div>

      <div class="col-right px-2">
        <div class="new-info">
          <div class="list-title">
            <v-icon class="mt-n1">
              mdi-note-text-outline
            </v-icon>
            New Information
          </div>

          <!-- Notice -->
          <div v-for="(item, idx) in noticeList" :key="'new-info_' + idx" class="new-info pt-1 d-flex">
            <div v-if="idx === 0" class="group-title d-flex justify-end px-1 mr-3" @click.stop="goNoticeList">
              Notice
            </div>

            <div v-else class="group-none-title d-flex justify-end mr-3" />

            <div class="item-title mr-3" @click.stop="selectNoticeContent(item)">
              <v-icon class="mt-n1">
                mdi-arrow-right-box
              </v-icon>
              {{ item.title }}
            </div>

            <div class="item-dt d-flex justify-center">
              {{ item.stDte }}
            </div>
          </div>

          <!-- Quotations -->
          <div v-for="(item, idx) in quotationList" :key="'quotation_' + idx" class="quotation pt-1 d-flex" :class="[item.seq === '1' ? 'mt-2' : '']">
            <div v-if="item.seq === '1'" class="group-title d-flex justify-end px-1 mr-3" @click.stop="goList(item.quotStepDesc)">
              {{ item.quotStepDesc }}
            </div>

            <div v-else class="group-none-title d-flex justify-end mr-3" />

            <div class="item-title mr-3" @click.stop="goDetail('quotation', item.quotNo)">
              <v-icon class="mt-n1">
                mdi-arrow-right-box
              </v-icon>
              {{ item.quotTitle }}
            </div>

            <div class="item-dt d-flex justify-center mr-3">
              {{ item.stDte}}
            </div>

            <div class="item-dt d-flex justify-center">
              {{ item.fiDte }}
            </div>
          </div>

          <!-- P/I -->
          <div v-for="(item, idx) in piList" :key="'pi_' + idx" class="pi pt-1 d-flex" :class="[item.seq === '1' ? 'mt-2' : '']">
            <div v-if="item.seq === '1'" class="group-title d-flex justify-end px-1 mr-3" @click.stop="goList(item.quotStepDesc)">
              {{ item.quotStepDesc }}
            </div>

            <div v-else class="group-none-title d-flex justify-end mr-3" />

            <div class="item-title mr-3" @click.stop="goDetail('pi', item.quotNo)">
              <v-icon class="mt-n1">
                mdi-arrow-right-box
              </v-icon>
              {{ item.quotTitle }}
            </div>

            <div class="item-dt d-flex justify-center mr-3">
              {{ item.stDte}}
            </div>

            <div class="item-dt d-flex justify-center">
              {{ item.fiDte }}
            </div>
          </div>

          <!-- Bidding -->
          <div v-for="(item, idx) in biddingList" :key="'bidding_' + idx" class="bidding pt-1 d-flex" :class="[item.seq === '1' ? 'mt-2' : '']">
            <div v-if="item.seq === '1'" class="group-title d-flex justify-end px-1 mr-3" @click.stop="goList(item.quotStepDesc)">
              {{ item.quotStepDesc }}
            </div>

            <div v-else class="group-none-title d-flex justify-end mr-3" />

            <div class="item-title mr-3" @click.stop="goDetail('bidding', item.quotNo)">
              <v-icon class="mt-n1">
                mdi-arrow-right-box
              </v-icon>
              {{ item.quotTitle }}
            </div>

            <div class="item-dt d-flex justify-center mr-3">
              {{ item.stDte}}
            </div>

            <div class="item-dt d-flex justify-center">
              {{ item.fiDte }}
            </div>
          </div>

          <!-- Success -->
          <div v-for="(item, idx) in successList" :key="'success_' + idx" class="suces pt-1 d-flex" :class="[idx === 0 ? 'mt-2' : '']">
            <div v-if="idx === 0" class="group-title d-flex justify-end px-1 mr-3" @click.stop="goList('Success')">
              Success
            </div>

            <div v-else class="group-none-title d-flex justify-end mr-3" />

            <div class="item-title mr-3" @click.stop="goDetail('success', item.poNo)">
              <v-icon class="mt-n1">
                mdi-arrow-right-box
              </v-icon>
              {{ item.poTitle }}
            </div>

            <div class="item-dt d-flex justify-center">
              {{ item.poDte }}
            </div>
          </div>

          <!-- P.O. -->
          <div v-for="(item, idx) in poList" :key="'po_' + idx" class="po pt-1 d-flex" :class="[idx === 0 ? 'mt-2' : '']">
            <div v-if="idx === 0" class="group-title d-flex justify-end px-1 mr-3" @click.stop="goList('P.O.')">
              P.O.
            </div>

            <div v-else class="group-none-title d-flex justify-end mr-3" />

            <div class="item-title mr-3"  @click.stop="goDetail('po', item.poNo)">
              <v-icon class="mt-n1">
                mdi-arrow-right-box
              </v-icon>
              {{ item.poTitle }}
            </div>

            <div class="item-dt d-flex justify-center">
              {{ item.poDte }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <noticeListPop :showNoticeListPop.sync="showNoticeListPop" />
    <noticeContentsPop :showNoticeContentsPop.sync="showNoticeContentsPop" :bulletinNo="selectBulletinNo" :title="selectNoticeTitle" />
    <chargerListPop :showChargerListPop.sync="showChargerListPop" />
    <contactUsPop :showContactUsPop.sync="showContactUsPop" />
    <processEPop :showProcessEPop.sync="showProcessEPop" />
    <processVPop :showProcessVPop.sync="showProcessVPop" />
    <surveyPop :showSurveyPop.sync="showSurveyPop" />
  </v-container>
</template>

<script>
import {
  getQuotations,
  getPI,
  getBidding,
  getSuccess,
  getPO,
  getDelPlanCnt,
  getDelOrderCnt,
  getDemMarkCnt,
  getNoticeList
} from '@/api/view/hip/Z/epms0100'
import { getCheckSurvey, getSurveyResult }  from '@/api/view/hip/common/common'
import noticeListPop from '@/views/hip/Z/popup/noticeListPop'
import chargerListPop from '@/views/hip/Z/popup/chargerListPop'
import noticeContentsPop from '@/views/hip/Z/popup/noticeContentsPop'
import contactUsPop from '@/views/hip/Z/popup/contactUsPop'
import processEPop from '@/views/hip/Z/popup/processEPop'
import processVPop from '@/views/hip/Z/popup/processVPop'
import surveyPop from '@/views/hip/Z/popup/surveyPop'

export default {
  name: 'epms0100',
  components: {
    noticeListPop,
    noticeContentsPop,
    chargerListPop,
    contactUsPop,
    processEPop,
    processVPop,
    surveyPop
  },
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      countList: [],
      
      btnList: [
        { title: 'Charger' },
        { title: 'HiP Process(E)' },
        { title: 'HiP Process(V)' },
        { title: 'Adobe Reader' },
        { title: 'Contact Us' },
        { title: 'Notice' },
        { title: 'Make survey' }
      ],
      surveyCnt: 0 ,
      noticeList: [],
      quotationList: [],
      piList: [],
      biddingList: [],
      successList: [],
      poList: [],
      surveyRst : [],
      selectBulletinNo: '',
      selectNoticeTitle: '',
      showNoticeListPop: false,
      showNoticeContentsPop: false,
      showChargerListPop: false,
      showContactUsPop: false,
      showProcessEPop: false,
      showProcessVPop: false,
      showSurveyPop: false
    }
  },
  methods: {
    async searchWhatsNew() {
      this.countList = []
      this.quotationList = []
      this.piList = []
      this.biddingList = []
      this.successList = []
      this.poList = []

      const param = {
        userId: this.$store.state.user.userId,
        makerCd: this.makerCd
      }
      // console.log('param', param)

      await getQuotations(param).then(res => {
        // console.log('getQuotations Res', res)

        this.countList.push({
          title: 'Quotation', cnt: res.list.length
        })

        this.quotationList = this.$_.cloneDeep(res.list)
      })
      
      await getPI(param).then(res => {
        // console.log('getPI Res', res)

        this.countList.push({
          title: 'P / I', cnt: res.list.length
        })

        this.piList = this.$_.cloneDeep(res.list)
      })

      await getBidding(param).then(res => {
        // console.log('getBidding Res', res)

        this.countList.push({
          title: 'Bidding', cnt: res.list.length
        })

        this.biddingList = this.$_.cloneDeep(res.list)
      })

      await getSuccess(param).then(res => {
        // console.log('getSuccess Res', res)

        this.countList.push({
          title: 'Success', cnt: res.list.length
        })

        this.successList = this.$_.cloneDeep(res.list)
      })

      await getPO(param).then(res => {
        // console.log('getPO Res', res)

        this.countList.push({
          title: 'P.O.', cnt: res.list.length
        })

        this.poList = this.$_.cloneDeep(res.list)
      })

      await getDelPlanCnt(param).then(res => {
        // console.log('getDelPlanCnt Res', res)

        this.countList.push({
          title: 'Delivery Plan', cnt: res.tcnt
        })
      })

      await getDemMarkCnt(param).then(res => {
        //console.log('getDemMarkCnt Res', res)

        this.countList.push({
          title: 'Demerit Mark', cnt: res.tcnt
        })
      })

      if(this.makerCd === '90263'|| this.makerCd === '95987') {
        await getDelOrderCnt(param).then(res => {
          // console.log('getDelOrderCnt Res', res)

          this.countList.push({
            title: 'Delivery Order', cnt: res.tcnt
          })
        })
      }

      
      // console.log('this.quotationList', this.quotationList)
      // console.log('this.piList', this.piList)
      // console.log('this.biddingList', this.biddingList)
      // console.log('this.successList', this.successList)
      // console.log('this.poList', this.poList)
    },
    goSurvey() {
      const param2 = {
        sysNo: "HIP",
        surveyId: "001",
        makerCd: this.makerCd
      }

      this.surveyCnt = 0
      getCheckSurvey(param2).then(res => {
        // console.log('getDemMarkCnt Res', res)
        this.surveyCnt = res.tcnt
        console.log('getCheckSurvey Res', res.tcnt)
        if(this.surveyCnt == 0 ) {
          this.showSurveyPop = true
        }
      })
    },

    searchNoticeList() {
      this.noticeList = []

      getNoticeList().then(res => {
        // console.log('res', res)
        this.noticeList = res.list
      })
    },
    goList(item) {
      let view = ''
      switch(item) {
        case 'Quotation':
          view = '/epms1000'
          break
        case 'P / I':
          view = '/epms2000'
          break
        case 'Bidding':
          view = '/epms3000'
          break
        case 'Success':
          view = '/epms4020'
          break
        case 'P.O.':
          view = '/epms4000'
          break
        case 'Delivery Plan':
          view = '/epms5060'
          break
        case 'Delivery Order':
          view = '/epms9050'
          break
        case 'Demerit Mark':
          view = '/epms0300'
          break
      }

      if(view) {
        this.$router.push(view).catch((() => {
          this.vToastify(this.$t('View does not exist.'), 'warn')
        }))
      }
    },
    goDetail(item, data) {
      // console.log('goDetail', `item: ${item}, data: ${data}`)

      switch(item) {
        case 'quotation':
          this.$router.push({ name: 'epms1010', params: { quotNo: data }})
          break
        case 'pi':
          this.$router.push({ name: 'epms2010', params: { quotNo: data } })
          break
        case 'bidding':
          this.$router.push({ name: 'epms3010', params: { quotNo: data } })
          break
        case 'po':
          this.$router.push({ name: 'epms4010', params: { poNo: data } })
          break
        case 'success':
          this.$router.push({ name: 'epms4030', params: { poNo: data } })
          break
      }
    },
    goNoticeList() {
      this.showNoticeListPop = true
    },

    clickBtns(item) {
      switch(item) {
        case 'Charger':
          this.showChargerListPop = true
          break
        case 'HiP Process(E)':
          this.showProcessEPop = true
          break
        case 'HiP Process(V)':
          this.showProcessVPop = true
          break
        case 'Adobe Reader':
          window.open('http://get.adobe.com/reader/')
          break
        case 'Contact Us':
          this.showContactUsPop = true
          break
        case 'Notice':
          this.goNoticeList()
          break
        case 'Make survey':
          this.showSurveyPop = true
          break
      }
    },
    selectNoticeContent(item) {
      this.selectBulletinNo = item.bulletinNo
      this.selectNoticeTitle = item.title
      this.showNoticeContentsPop = true
    }
  },
  mounted() {
    this.searchWhatsNew()
    this.searchNoticeList()
    if(this.$store.state.user.userId != 'ADMIN' ) {
      this.goSurvey()
    }
  }
}
</script>

<style lang="scss" scoped>
$groupTitleWidth: 140px;

.epms0100-main .col-left {
  // background: skyblue;
  width: 250px;
}

.epms0100-main .col-right {
  // background: grey;
  // width: 900px;
}

.list-title {
  font-size: 20px;
  font-weight: bold;
}

.whats-new .item-title {
  width: 160px;
  border-bottom: 1px dashed black;
  font-weight: bold;
}

.whats-new .item-cnt {
  width: 50px;
  border-bottom: 1px dashed black;
}

.new-info .group-title {
  width: #{$groupTitleWidth};
  border-bottom: 1px dashed black;
  font-weight: bold;
}

.new-info .group-none-title {
  width: #{$groupTitleWidth};
  font-size: 12px;
}

.new-info .item-title {
  width: 650px;
  border-bottom: 1px dashed black;
  font-size: 12px;
}

.new-info .item-dt {
  width: 80px;
  border-bottom: 1px dashed black;
  font-size: 12px;
}

.item-title:hover, .group-title:hover {
  cursor: pointer;
  color:  #007cdc;
  font-weight: bold;
}

.v-btn {
  color: blue;
  text-transform: unset !important;
}

.v-btn .v-icon {
  color: rgba(0, 0, 0, 0.54);
}
div.sv_window {  
 position: absolute !important; 
 top: 0 !important;  
 left: 0 !important;  
 width: 50% !important;  
 height: 100% !important;  
}
</style>